import React, { useState } from 'react'

import { useParams, useHistory, Link } from 'react-router-dom'

import { Descriptions, Divider, Tabs, Button, Alert } from 'antd'

import { DollarOutlined, PercentageOutlined } from '@ant-design/icons'

import { LAYOUT_MANAGER_CLIENT_EDIT, LAYOUT_MANAGER_CLIENT_AGREEMENT_SHOW } from '../../navigation'

import Profile from '../../../../core/components/profile'
import ClientInformation from './information'
import PriceList from '../../../../components/price/list'

import { useFetch } from '../../../../hooks/manager/client'
import Loader from '../../../../components/loader'

const { TabPane } = Tabs
//import Account from "./account";
//import ListadoMovimientos from '../components/movimientos'

const Show = (props) => {
  const { id } = useParams()
  const history = useHistory()
  const [catlog, setCatlog] = useState(1)
  const onPressBack = () => history.goBack()

  const { data, isLoading, isError } = useFetch(id)

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  return (
    <Profile
      onBack={onPressBack}
      mainTitle='Client'
      ainSubtitle='subtitle'
      mainExtra={[
        <Link key='1' to={LAYOUT_MANAGER_CLIENT_EDIT(id)}>
          <Button type='primary' size='small'>
            <i className='fa fa-pencil-square-o' />
            <Divider type='vertical' />
            Update
          </Button>
        </Link>
      ]}
      renderInformation={() => <ClientInformation client={data.client} />}
    >
      <h2 className='after-underline'>General</h2>
      <Descriptions size='medium' column={3}>
        <Descriptions.Item label='Notes'> {data.client.notes} </Descriptions.Item>
      </Descriptions>

      <Divider orientation='left' plain />

      {(data.agreement || []).length === 0 && (
        <Alert type='error' message='Please establish an agreement for this client.' banner showIcon />
      )}
      {(data.client.prices || []).length === 0 && (
        <Alert
          type='error'
          message='Please set the prices associated with this customer.'
          banner
          showIcon
        />
      )}

      <Tabs defaultActiveKey='prices'>
        <TabPane
          tab={
            <span>
              {' '}
              <DollarOutlined /> Basic Prices{' '}
            </span>
          }
          key='prices'
          style={{ minHeight: 400 }}
        >
          <Descriptions size='medium' column={1}>
            <Descriptions.Item label='Currency'>
              {data.client.currency ? data.client.currency.name : ''}
            </Descriptions.Item>
            <Descriptions.Item label='Rush fee percent'>
              {' '}
              {parseFloat(data.client.rush_percent).toFixed(0) + '%'}{' '}
            </Descriptions.Item>
          </Descriptions>
          <br />

          <PriceList
            prices={data.client.prices}
          />
        </TabPane>

        <TabPane
          tab={
            <span>
              {' '}
              <PercentageOutlined /> Agreements{' '}
            </span>
          }
          key='agreement'
          style={{ minHeight: 400 }}
        >
          <Tabs
            tabPosition='left'
            size='small'
            tabBarExtraContent={
              <Link
                key='1'
                size='small'
                to={LAYOUT_MANAGER_CLIENT_AGREEMENT_SHOW(id, catlog)}
                className='ant-btn ant-btn-primary'
              >
                % Update
              </Link>
            }
            onChange={(key) => setCatlog(key)}
          >
            {(data.catlogs || []).map((item) => (
              <TabPane tab={item.name} key={item.id.toString()}>
                <Descriptions size='small' column={3}>
                  {(item.values || []).map((pos) => {
                    const a = data.agreement.find((x) => x.catlogValue == pos.id)
                    let percent = 'no data'
                    if (a) {
                      percent = a.percent + '%'
                    }
                    return (
                      <Descriptions.Item key={pos.id} label={pos.name}>
                        {percent}
                      </Descriptions.Item>
                    )
                  })}
                </Descriptions>
              </TabPane>
            ))}
          </Tabs>
        </TabPane>

        {/*
            <TabPane
                tab={
                    <span>
                        {" "}
                        <BankOutlined /> Account{" "}
                    </span>
                }
                key="account"
                style={{ minHeight: 400 }}
            >
                <Account movements={data.movements} balance={data.balance} client={data.client} />
            </TabPane>
        */}
        {/*
            <TabPane
                tab={
                    <span>
                        {" "}
                        <FolderOpenOutlined /> Files{" "}
                    </span>
                }
                key="files"
                style={{ minHeight: 400 }}
            >
                
                <BoxBrowser
                    folderId={0}
                    height={600}
                    created={true }
                />
            </TabPane>
          */}
      </Tabs>
    </Profile>
  )
}

export default Show

/*
export default class Show extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: props.match.params.id,
            catlog: 1,
        }
    }

    _goBack = () => {
        this.props.history.goBack()
    };

    render() {
        const { data } = this.props
        const { servicesById, categoriesById, languagesById, languagePairsById, unitsById } = this.props

        return (
            <Profile
                onBack={this._goBack}
                mainTitle="Client"
                ainSubtitle="subtitle"
                mainExtra={[
                    <Link key="1" to={LAYOUT_MANAGER_CLIENT_EDIT(this.state.id)}>
                        <Button type="primary" size="small">
                            <i className="fa fa-pencil-square-o"></i>
                            <Divider type="vertical" />
                            Update
                        </Button>
                    </Link>,
                ]}
                renderInformation={() => <ClientInformation client={data.client} />}
            >
                <h2 className="after-underline">General</h2>
                <Descriptions size="medium" column={3}>
                    <Descriptions.Item label="Notes"> {data.client.notes} </Descriptions.Item>
                </Descriptions>

                <Divider orientation="left" plain />

                {(data.agreement || []).length == 0 && (
                    <Alert type="error" message="Please establish an agreement for this client." banner showIcon />
                )}
                {(data.client.prices || []).length === 0 && (
                    <Alert
                        type="error"
                        message="Please set the prices associated with this customer."
                        banner
                        showIcon
                    />
                )}

                <Tabs defaultActiveKey="prices">
                    <TabPane
                        tab={
                            <span>
                                {' '}
                                <DollarOutlined /> Basic Prices{' '}
                            </span>
                        }
                        key="prices"
                        style={{ minHeight: 400 }}
                    >
                        <Descriptions size="medium" column={1}>
                            <Descriptions.Item label="Currency">
                                {data.client.currency ? data.client.currency.name : ''}
                            </Descriptions.Item>
                            <Descriptions.Item label="Rush fee percent">
                                {' '}
                                {parseFloat(data.client.rush_percent).toFixed(0) + '%'}{' '}
                            </Descriptions.Item>
                        </Descriptions>
                        <br />

                        <PriceList
                            prices={data.client.prices}
                            servicesById={servicesById}
                            categoriesById={categoriesById}
                            languagesById={languagesById}
                            languagePairsById={languagePairsById}
                            unitsById={unitsById}
                        />
                    </TabPane>

                    <TabPane
                        tab={
                            <span>
                                {' '}
                                <PercentageOutlined /> Agreements{' '}
                            </span>
                        }
                        key="agreement"
                        style={{ minHeight: 400 }}
                    >
                        <Tabs
                            tabPosition="left"
                            size="small"
                            tabBarExtraContent={
                                <Link
                                    key="1"
                                    size="small"
                                    to={LAYOUT_MANAGER_CLIENT_AGREEMENT_SHOW(this.state.id, this.state.catlog)}
                                    className="ant-btn ant-btn-primary"
                                >
                                    % Update
                                </Link>
                            }
                            onChange={(key) => this.setState({ catlog: key })}
                        >
                            {(data.catlogs || []).map((item) => (
                                <TabPane tab={item.name} key={item.id.toString()}>
                                    <Descriptions size="small" column={3}>
                                        {(item.values || []).map((pos) => {
                                            const a = data.agreement.find((x) => x.catlogValue == pos.id)
                                            let percent = 'no data'
                                            if (a) {
                                                percent = a.percent + '%'
                                            }
                                            return (
                                                <Descriptions.Item key={pos.id} label={pos.name}>
                                                    {percent}
                                                </Descriptions.Item>
                                            )
                                        })}
                                    </Descriptions>
                                </TabPane>
                            ))}
                        </Tabs>
                    </TabPane>
                </Tabs>
            </Profile>
        )
    }
}*/
